const dados = [
  {
    bbox: [63.464, 389.2884, 541.44704, 498.4988827586206],
    data: [
      {
        "": "Título de Cada Classe",
        "Símbolo(s) de": "Negociação",
        "Valores Mobiliários são": "Registrados",
      },
      {
        "": "Ações ordinárias da Vale, sem valor nominal por ação",
        "Símbolo(s) de": "",
        "Valores Mobiliários são": "Bolsa de Valores de Nova York*",
      },
      {
        "": "American Depositary Shares (evidenciadas pelos American Depositary Receipts), cada uma",
        "Símbolo(s) de": "",
        "Valores Mobiliários são": "",
      },
      {
        "": "representandouma ação ordinária da Vale",
        "Símbolo(s) de": "VALE",
        "Valores Mobiliários são": "Bolsa de Valores de Nova York",
      },
      {
        "": "6,250% em Notas Garantidas com vencimento em 2026, emitidas pela Vale Overseas",
        "Símbolo(s) de": "VALE/26",
        "Valores Mobiliários são": "Bolsa de Valores de Nova York",
      },
      {
        "": "3,750% em Notas Garantidas com vencimento em 2030, emitidas pela Vale Overseas",
        "Símbolo(s) de": "VALE/30",
        "Valores Mobiliários são": "Bolsa de Valores de Nova York",
      },
      {
        "": "8,250% em Notas Garantidas com vencimento em 2034, emitidas pela Vale Overseas",
        "Símbolo(s) de": "VALE/34",
        "Valores Mobiliários são": "Bolsa de Valores de Nova York",
      },
      {
        "": "6,875% em Notas Garantidas com vencimento em 2036, emitidas pela Vale Overseas",
        "Símbolo(s) de": "VALE/36",
        "Valores Mobiliários são": "Bolsa de Valores de Nova York",
      },
      {
        "": "6,875% em Notas Garantidas com vencimento em 2039, emitidas pela Vale Overseas",
        "Símbolo(s) de": "VALE39",
        "Valores Mobiliários são": "Bolsa de Valores de Nova York",
      },
      {
        "": "5,625% em Notas com vencimento em 2042, emitidas pela Vale S.A.",
        "Símbolo(s) de": "VALE42",
        "Valores Mobiliários são": "Bolsa de Valores de Nova York",
      },
    ],
    headers: ["", "Símbolo(s) de", "Valores Mobiliários são"],
    isSelected: false,
    page: 1,
    title: "",
  },
  {
    bbox: [67.424, 422.0616, 546.431, 646.090918181818],
    data: [
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Minerais ferrosos",
        "2021 Em milhões de US$": "",
        "% do total": "",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "",
        "% do total 2": "",
        "2019 Em milhões de US$": "",
        "% do total 3": "",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Minério de ferro",
        "2021 Em milhões de US$": "38.701",
        "% do total": "71,0",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "27.285",
        "% do total 2": "69,0",
        "2019 Em milhões de US$": "23.343",
        "% do total 3": "63,9",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Pelotas de minério de ferro",
        "2021 Em milhões de US$": "7.053",
        "% do total": "12,9",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "4.242",
        "% do total 2": "10,7",
        "2019 Em milhões de US$": "5.948",
        "% do total 3": "16,3",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ": "Manganês",
        "2021 Em milhões de US$": "175",
        "% do total": "0,3",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "225",
        "% do total 2": "0,6",
        "2019 Em milhões de US$": "282",
        "% do total 3": "0,8",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Outros produtos ferrosos e",
        "2021 Em milhões de US$": "",
        "% do total": "",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "",
        "% do total 2": "",
        "2019 Em milhões de US$": "",
        "% do total 3": "",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ": "serviços",
        "2021 Em milhões de US$": "373",
        "% do total": "0,7",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "326",
        "% do total 2": "0,8",
        "2019 Em milhões de US$": "432",
        "% do total 3": "1,2",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Minerais ferrosos - total",
        "2021 Em milhões de US$": "46.302",
        "% do total": "85,0",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "32.078",
        "% do total 2": "81,1",
        "2019 Em milhões de US$": "30.005",
        "% do total 3": "82,1",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Metais básicos",
        "2021 Em milhões de US$": "",
        "% do total": "",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "",
        "% do total 2": "",
        "2019 Em milhões de US$": "",
        "% do total 3": "",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Níquel e outros produtos ",
        "2021 Em milhões de US$": "5.377",
        "% do total": "9,9",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "4.652",
        "% do total 2": "11,8",
        "2019 Em milhões de US$": "3.954",
        "% do total 3": "10,8",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ": "Cobre ",
        "2021 Em milhões de US$": "2.589",
        "% do total": "4,8",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "2.175",
        "% do total 2": "5,5",
        "2019 Em milhões de US$": "1.904",
        "% do total 3": "5,2",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Metais básicos - total",
        "2021 Em milhões de US$": "7.966",
        "% do total": "14,6",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "6.827",
        "% do total 2": "17,3",
        "2019 Em milhões de US$": "5.858",
        "% do total 3": "16,0",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ": "Outros",
        "2021 Em milhões de US$": "234",
        "% do total": "0,4",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "640",
        "% do total 2": "1,6",
        "2019 Em milhões de US$": "686",
        "% do total 3": "1,9",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "Total de receitas operacionais",
        "2021 Em milhões de US$": "",
        "% do total": "",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "",
        "% do total 2": "",
        "2019 Em milhões de US$": "",
        "% do total 3": "",
      },
      {
        "nossas linhas de negócios com operações continuadas.    ":
          "líquidas das operações continuadas",
        "2021 Em milhões de US$": "54.502",
        "% do total": "100",
        "Ano findo em 31 de dezembro de 2020 Em milhões de US$": "39.545",
        "% do total 2": "100",
        "2019 Em milhões de US$": "36.549",
        "% do total 3": "100",
      },
    ],
    headers: [
      "nossas linhas de negócios com operações continuadas.    ",
      "2021 Em milhões de US$",
      "% do total",
      "Ano findo em 31 de dezembro de 2020 Em milhões de US$",
      "% do total 2",
      "2019 Em milhões de US$",
      "% do total 3",
    ],
    isSelected: false,
    page: 5,
    title: "",
  },
  {
    bbox: [67.424, 602.13, 547.169, 757.9286792452829],
    data: [
      {
        "": "Instalações e infraestrutura",
        "SEGMENTOS DE NEGÓCIOS":
          "Planta de processamento: O processo de beneficiamento para o minério bruto (run",
      },
      {
        "": "associadas",
        "SEGMENTOS DE NEGÓCIOS":
          "of mine) consiste em etapas padrão de britagem e classificação, produzindo",
      },
      { "": "", "SEGMENTOS DE NEGÓCIOS": "minério granulado e sinter feed." },
      {
        "": "",
        "SEGMENTOS DE NEGÓCIOS":
          "Outras instalações: Estruturas de disposição de resíduos e rejeitos.",
      },
      {
        "": "",
        "SEGMENTOS DE NEGÓCIOS":
          "Logística: Transportado por balsas que percorrem os rios Paraguai e Paraná, para",
      },
      {
        "": "",
        "SEGMENTOS DE NEGÓCIOS":
          "clientes ao longo da hidrovia e por transbordos no porto de Nueva Palmira no",
      },
      {
        "": "",
        "SEGMENTOS DE NEGÓCIOS": "Uruguai, ou entregues a clientes em Corumbá.",
      },
      {
        "": "",
        "SEGMENTOS DE NEGÓCIOS":
          "Energia: Fornecida através da rede elétrica nacional. Adquirida por meio de",
      },
      { "": "", "SEGMENTOS DE NEGÓCIOS": "contratos de compra de energia." },
    ],
    headers: ["", "SEGMENTOS DE NEGÓCIOS"],
    isSelected: false,
    page: 6,
    title: "",
  },
  {
    bbox: [67.784, 286.8016, 546.551, 555.5402792452828],
    data: [
      {
        "Mina/Usina": "",
        Tipo: "",
        "2021(1)": "",
        "Produção para o ano findo em 31 de dezembro de 2020(1)":
          "(milhões de toneladas métricas)",
        "2019(1)": "",
        "Recuperação no beneficiamento 2021(2)": "(%)",
      },
      {
        "Mina/Usina": "Sistema Sudeste",
        Tipo: "",
        "2021(1)": "",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "",
        "2019(1)": "",
        "Recuperação no beneficiamento 2021(2)": "",
      },
      {
        "Mina/Usina": "Itabira",
        Tipo: "Lavra a céu aberto",
        "2021(1)": "28,7",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "23,9",
        "2019(1)": "35,9",
        "Recuperação no beneficiamento 2021(2)": "55,7",
      },
      {
        "Mina/Usina": "Minas Centrais",
        Tipo: "Lavra a céu aberto",
        "2021(1)": "19,3",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "15,7",
        "2019(1)": "25,9",
        "Recuperação no beneficiamento 2021(2)": "80,4",
      },
      {
        "Mina/Usina": "Mariana",
        Tipo: "Lavra a céu aberto",
        "2021(1)": "21,8",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "17,7",
        "2019(1)": "11,3",
        "Recuperação no beneficiamento 2021(2)": "83,0",
      },
      {
        "Mina/Usina": "Total Sistema Sudeste",
        Tipo: "",
        "2021(1)": "69,8",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "57,3",
        "2019(1)": "73,1",
        "Recuperação no beneficiamento 2021(2)": "71,0",
      },
      {
        "Mina/Usina": "Sistema Sul",
        Tipo: "",
        "2021(1)": "",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "",
        "2019(1)": "",
        "Recuperação no beneficiamento 2021(2)": "",
      },
      {
        "Mina/Usina": "Vargem Grande",
        Tipo: "Lavra a céu aberto",
        "2021(1)": "31,3",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "25,1",
        "2019(1)": "13,1",
        "Recuperação no beneficiamento 2021(2)": "85,6",
      },
      {
        "Mina/Usina": "Paraopeba",
        Tipo: "Lavra a céu aberto",
        "2021(1)": "23,0",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "23,3",
        "2019(1)": "24,7",
        "Recuperação no beneficiamento 2021(2)": "63,4",
      },
      {
        "Mina/Usina": "Total Sistema Sul",
        Tipo: "",
        "2021(1)": "54,3",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "48,4",
        "2019(1)": "37,8",
        "Recuperação no beneficiamento 2021(2)": "76,2",
      },
      {
        "Mina/Usina": "Sistema Norte",
        Tipo: "",
        "2021(1)": "",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "",
        "2019(1)": "",
        "Recuperação no beneficiamento 2021(2)": "",
      },
      {
        "Mina/Usina": "Serra Norte",
        Tipo: "Lavra a céu aberto",
        "2021(1)": "109,3",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "109,41",
        "2019(1)": "115,3",
        "Recuperação no beneficiamento 2021(2)": "97,3",
      },
      {
        "Mina/Usina": "Serra Sul",
        Tipo: "Lavra a céu aberto",
        "2021(1)": "73,7",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "82,9",
        "2019(1)": "73,4",
        "Recuperação no beneficiamento 2021(2)": "100,0",
      },
      {
        "Mina/Usina": "Serra Leste",
        Tipo: "",
        "2021(1)": "5,9",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "0,3",
        "2019(1)": "0,1",
        "Recuperação no beneficiamento 2021(2)": "99,7",
      },
      {
        "Mina/Usina": "Total Sistema Norte",
        Tipo: "",
        "2021(1)": "188,8",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "192,3",
        "2019(1)": "188,7",
        "Recuperação no beneficiamento 2021(2)": "97,9",
      },
      {
        "Mina/Usina": "Sistema Centro-Oeste",
        Tipo: "",
        "2021(1)": "",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "",
        "2019(1)": "",
        "Recuperação no beneficiamento 2021(2)": "",
      },
      {
        "Mina/Usina": "MCR",
        Tipo: "Lavra a céu aberto",
        "2021(1)": "2,7",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "2,5",
        "2019(1)": "2,4",
        "Recuperação no beneficiamento 2021(2)": "76,6",
      },
      {
        "Mina/Usina": "Total Sistema Centro-Oeste",
        Tipo: "",
        "2021(1)": "2,7",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "2,5",
        "2019(1)": "2,4",
        "Recuperação no beneficiamento 2021(2)": "76,6",
      },
      {
        "Mina/Usina": "Total",
        Tipo: "",
        "2021(1)": "315,6",
        "Produção para o ano findo em 31 de dezembro de 2020(1)": "300,4",
        "2019(1)": "302,0",
        "Recuperação no beneficiamento 2021(2)": "88,0",
      },
    ],
    headers: [
      "Mina/Usina",
      "Tipo",
      "2021(1)",
      "Produção para o ano findo em 31 de dezembro de 2020(1)",
      "2019(1)",
      "Recuperação no beneficiamento 2021(2)",
    ],
    isSelected: false,
    page: 6,
    title: "",
  },
  {
    bbox: [67.424, 559.17, 292.596, 685.2265818181817],
    data: [
      {
        "Coordenadas centrais UTM das minas de Serra Norte, Datum SAD69 Mina":
          "N4",
        Status: "Em operação",
        "UTM E": "590.140",
        "UTM N": "9.329.567",
      },
      {
        "Coordenadas centrais UTM das minas de Serra Norte, Datum SAD69 Mina":
          "N5",
        Status: "Em operação",
        "UTM E": "596.410",
        "UTM N": "9.328.668",
      },
      {
        "Coordenadas centrais UTM das minas de Serra Norte, Datum SAD69 Mina":
          "N1",
        Status: "Não operante",
        "UTM E": "579.891",
        "UTM N": "9.333.075",
      },
      {
        "Coordenadas centrais UTM das minas de Serra Norte, Datum SAD69 Mina":
          "N2",
        Status: "Não operante",
        "UTM E": "583.351",
        "UTM N": "9.330.472",
      },
      {
        "Coordenadas centrais UTM das minas de Serra Norte, Datum SAD69 Mina":
          "N3",
        Status: "Não operante",
        "UTM E": "587.140",
        "UTM N": "9.331.790",
      },
    ],
    headers: [
      "Coordenadas centrais UTM das minas de Serra Norte, Datum SAD69 Mina",
      "Status",
      "UTM E",
      "UTM N",
    ],
    isSelected: false,
    page: 7,
    title: "",
  },
  {
    bbox: [62.024, 391.14, 552.554, 677.8983999999998],
    data: [
      {
        "": "Provada",
        Tonelagem: "464,3",
        Teor: "66,1",
        "Tonelagem 2": "554,0",
        "Teor 2": "66,1",
        metalúrgica: "",
      },
      {
        "": "Provável",
        Tonelagem: "1.125,9",
        Teor: "65,7",
        "Tonelagem 2": "1.163,2",
        "Teor 2": "65,6",
        metalúrgica: "98,9%",
      },
      {
        "": "Total",
        Tonelagem: "1.590,2",
        Teor: "65,8",
        "Tonelagem 2": "1.717,2",
        "Teor 2": "65,8",
        metalúrgica: "",
      },
    ],
    headers: ["", "Tonelagem", "Teor", "Tonelagem 2", "Teor 2", "metalúrgica"],
    isSelected: false,
    page: 10,
    title: "",
  },
];

export default dados;
